import React, { createContext, useContext, useState } from 'react';
import thresholds from '../thresholds';

export const ThresholdContext = createContext();

export const ThresholdProvider = ({ children }) => {
  const [thresholdsState, setThresholdsState] = useState(thresholds);

  const updateThreshold = (parameter, value) => {
    setThresholdsState((prev) => ({ ...prev, [parameter]: value }));
  };

  return (
    <ThresholdContext.Provider value={{ thresholds: thresholdsState, updateThreshold }}>
      {children}
    </ThresholdContext.Provider>
  );
};

export const useThresholds = () => useContext(ThresholdContext);
